import { INQUIRY_API_PATHS } from '../constants/api'
import type {
  B2bInquiryPayload,
  InquiryCreated,
  VendorInquiryPayload,
} from '../constants/inquiries'
import { apiRequest } from './client'

export function submitVendorInquiry(
  payload: VendorInquiryPayload,
): Promise<InquiryCreated> {
  return apiRequest<InquiryCreated>(INQUIRY_API_PATHS.vendor, {
    method: 'POST',
    body: payload,
  })
}

export function submitB2bInquiry(
  payload: B2bInquiryPayload,
): Promise<InquiryCreated> {
  return apiRequest<InquiryCreated>(INQUIRY_API_PATHS.b2b, {
    method: 'POST',
    body: payload,
  })
}
